import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UserLoginDetails from './user-login-details';
import UserLoginDetailsDetail from './user-login-details-detail';
import UserLoginDetailsUpdate from './user-login-details-update';
import UserLoginDetailsDeleteDialog from './user-login-details-delete-dialog';

const UserLoginDetailsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<UserLoginDetails />} />
    <Route path="new" element={<UserLoginDetailsUpdate />} />
    <Route path=":id">
      <Route index element={<UserLoginDetailsDetail />} />
      <Route path="edit" element={<UserLoginDetailsUpdate />} />
      <Route path="delete" element={<UserLoginDetailsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default UserLoginDetailsRoutes;
